import ComplianceWelcome from './ComplianceWelcome';
import RentersInsuranceLayout from '../../layouts/RentersInsuranceLayout';

const ComplianceWelcomeContainer = () => {
  return (
    <RentersInsuranceLayout headerProps={{ v2: true, isStickToTop: true }} footerProps={{ withMarginTop: true }}>
      <ComplianceWelcome />
    </RentersInsuranceLayout>
  )
};

export default ComplianceWelcomeContainer;
